<template>
  <a-modal
    :visible="visible"
    :confirm-loading="loading"
    :footer="null"
    @cancel="handleCancel"
  >
    <template #title>
      <div class="modal-title">폴더 생성</div>
    </template>
    
    <div class="modal-content">
      <a-form
        ref="folderForm"
        :model="formState"
        :rules="rules"
        layout="vertical"
      >
        <a-form-item 
          label="폴더 경로" 
          name="folderPath"
        >
          <a-input
            v-model:value="formState.folderPath"
            placeholder="생성할 폴더 경로를 입력하세요"
            allow-clear
          />
        </a-form-item>
      </a-form>

      <div class="modal-footer">
        <a-button @click="handleCancel">취소</a-button>
        <a-button 
          type="primary" 
          :loading="loading" 
          @click="handleSubmit"
        >생성</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from 'ant-design-vue';

export default defineComponent({
  name: 'CreateFolderModal',

  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      formState: {
        folderPath: ''
      },
      rules: {
        folderPath: [
          { required: true, message: '폴더 경로를 입력해주세요' }
        ]
      }
    }
  },

  methods: {
    async validateForm() {
      try {
        await this.$refs.folderForm.validate();
        return true;
      } catch (error) {
        return false;
      }
    },

    async handleSubmit() {
      const isValid = await this.validateForm();
      if (!isValid) return;

      if (!this.formState.folderPath) {
        message.warning('폴더 경로를 입력해주세요.');
        return;
      }

      this.loading = true;
      try {
        await this.$emit('create', this.formState.folderPath);
      } finally {
        this.loading = false;
      }
    },

    handleCancel() {
      this.formState.folderPath = '';
      this.$emit('update:visible', false);
    }
  }
});
</script>

<style lang="scss" scoped>
.modal-title {
  font-size: 16px;
  font-weight: bold;
}

.modal-content {
  padding: 20px;
  border: none;
  background: #fff;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
}

:deep(.ant-modal) {
  padding-bottom: 0;
  
  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    .ant-modal-close {
      color: rgba(0, 0, 0, 0.45);
    }

    .ant-modal-header {
      padding: 16px 20px;
      border: none;
      background: #fff;
      margin: 0;
    }

    .ant-modal-body {
      padding: 0;
      background: #fff;
      border: none;
    }

    .ant-modal-header,
    .ant-modal-body,
    .ant-modal-footer {
      border: none;
    }

    .ant-form-item {
      margin-bottom: 24px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style> 